const compareSettings = {
    categoryFamilies: [
        ['Conditions', 'Additional Conditions'],
        ['Exclusions', 'Property Not Covered'],
        [
            'Additional Coverages',
            'Coverage Extensions',
            'Covered Property',
            'Insuring Agreements',
            'Optional Coverages',
        ],
    ],
    similarityThreshold: 0.7,
};
export default compareSettings;
